import "./App.css";
import { Route, Routes } from "react-router-dom";
import Home from "./routes/Home";
import Contact from "./routes/Contact";
import MapHpiz from "./routes/MapHpiz ";


export default function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/contact" element={<Contact/>}/>
        <Route path="/mapHpiz" element={<MapHpiz/>}/>
      </Routes>
    
    </div>
  );
}
